import { useState } from "react";
import { useEffect } from "react";

import { Stack,Box } from "@mui/system";
import { Paper, FormControl, Select, MenuItem, Typography, FormLabel } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SubHeader } from "../../atoms/Typography/SubHeader/SubHeader";
import { getDoctorFullDetailsByID } from "../../../Api/Doctor/Doctor.Api";
import { ReactComponent as Close } from "../../../Assets/Images/Close.svg";
import { useAuth } from "../../../Store/AuthContext";
import CircularSpinner from "../../atoms/Spinner/CircularSpinner/CircularSpinner";
import { Heading1 } from "../../atoms/Typography/Heading/Heading";
import { DoctorInfoSection } from "../../organisms/DoctorProfileSections/DoctorInfoSection";
import { DoctorInfoSection2 } from "../../organisms/DoctorProfileSections/DoctorInfoSection2";
import ConsultationFeeTable from "../../molecules/ConsultationFeeTable/ConsultationFeeTable";
import RowWrap from "../../templates/RowWrap/RowWrap";
import { FormItemsWrap } from "../../molecules/Wrap/Wrap";
import { ReactComponent as ArrowDown } from "../../../Assets/Images/ArrowDown.svg";

export const DoctorProfile = ({ open, setOpen, docId, verifiedDocStatus }) => {
  const { t } = useTranslation();
  const { state } = useAuth();
  const [loading, setLoading] = useState(false);
  const [docDetails, setDocDetails] = useState(null);
  const [appType, setAppType] = useState("doctor");

  // Handle component on load
  useEffect(() => {
    if (open == true && !docDetails) {
      GetDocFullDetails();
    }
  }, [open]);

  useEffect(() => {
    GetDocFullDetails();
  }, [verifiedDocStatus]);

  // Get doctor details (full)
  const GetDocFullDetails = async () => {
    setLoading(true);
    try {
      let response = await getDoctorFullDetailsByID(docId, state.lang.code);
      if (response.type === 0) {
        setDocDetails(response.data);
        setLoading(false);
      }
    } catch (exception) {}
  };




 // const ratesMap = mapSpecialityRates(docDetails?.specialityRates);


  return (
    <>
      {open && loading && (
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            zIndex: 2,
            top: 0,
            left: 0,
            background: "rgba(0, 0, 0, 0.6)",
            overflow: "scroll",
          }}
        >
          <CircularSpinner />
        </div>
      )}
      {open && docDetails && !loading && (
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            zIndex: 2,
            top: 0,
            left: 0,
            background: "rgba(0, 0, 0, 0.6)",
            overflowY: "auto",
            overflow: "scroll",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100%",
              flexWrap: "revert",
            }}
          >
            <Stack
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
              position={"static"}
              rowGap={"28px"}
              backgroundColor={"#F7F8FA"}
              width={"1264px"}
              padding={"16px"}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "-10px",
                }}
              >
                <Heading1 text={t("glossary:doctor-details.profile")} />
                <Close
                  role="img"
                  type="img"
                  aria-label="Close Icon"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setOpen(false);
                  }}
                />
              </div>
              <RowWrap
                height={"auto"}
                flexDirection={"column"}
                children={
                  <>
                    <DoctorInfoSection data={docDetails} />
                  </>
                }
              />
              {console.log("first", docDetails)}
              <RowWrap
                text={t("glossary:doctor-details.consultations")}
                height={"auto"}
                flexDirection={"column"}
                gap={"17px"}
                children={
                  <>
                    <DoctorInfoSection2 data={docDetails} />
                  </>
                }
              />

              <RowWrap text="Consultation Fees" flexDirection="column">
                <FormControl sx={{ mb: 2, mt: 2, width: '200px',  }}>
                  <Select
                    value={appType}
                    onChange={(e) => setAppType(e.target.value)}
                    IconComponent={ArrowDown}
                    variant="outlined"
                    fullWidth
                    displayEmpty
                    style={{ fontSize: "13px" }}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#dbdbddff",
                      },
                      "& .MuiSelect-icon": {
                        marginRight: "11px",
                        width: "16px",
                        height: "16px",
                        top: "calc(50% - 8px)",
                      },
                    }}
                  >
                    <MenuItem value="doctor" style={{ fontSize: "13px" }}>
                      Doctor App
                    </MenuItem>
                    <MenuItem value="patient" style={{ fontSize: "13px" }}>
                      Patient App
                    </MenuItem>
                  </Select>
                </FormControl>
                <ConsultationFeeTable
                  speciality={docDetails.speciality}
                  ratesMap={{}}
                  isEdit={false}
                  appType={appType}
                />
              </RowWrap>

            </Stack>
          </div>
        </div>
      )}
    </>
  );
};
